import { connect } from 'react-redux'
import SsoCodeManager from './component'
import { actions, selectors, ltsLogin as ltsLoginImport } from '../../../../imports'
import { getActiveServer, getActiveServerId, getLocale } from '../../../../data'

function mapStateToProps(state) {
    const server = getActiveServer(state)
    const ltsLogin = ssoCode =>
        ltsLoginImport(
            server,
            ssoCode,
            false,
            selectors.getAutoLaunchOnLogin(state),
            getLocale(state),
        )
    return {
        ltsLogin,
    }
}

const logInUser = user => (dispatch, getState) => {
    const serverId = getActiveServerId(getState())
    dispatch(actions.logInUser(serverId, user))
    window.setToken()
}

const displayError = () => (dispatch, getState) => {
    const state = getState()
    const title = selectors.getErrorText(state)
    const message = selectors.getErrorLoginUserText(state)
    dispatch(actions.showError({ title, content: message }))
}

function mapDispatchToProps(dispatch) {
    return {
        loginUser: (user) => {
            dispatch(logInUser(user))
        },
        displayError: () => {
            dispatch(displayError())
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SsoCodeManager)



// WEBPACK FOOTER //
// ./src/features/Backend/components/Backend/components/SsoCodeManager/index.js